module.exports = __webpack_public_path__ + "img/jjfa_axxl.7ecc9a0f.png";